
import SingleOfferTemplate from './SingleOfferTemplate'

import { report } from '@src/common/decorators'
import { reportPV, reportImpressions, reportOfferImpression, onScreenClick } from '../../common/report'
import {reportUrls, sendImpressions, showNativeCloseBtn, hideNativeCloseBtn, setNativeCloseBtnDisplay} from '../../api/index'
import App from "../App";
import {checkIosSDKVersion, device} from "../../common/util";




class BannerTemplate extends SingleOfferTemplate{
    constructor(props={}) {
        super(props)
    }

    @report([{
        value: function(){
            //console.warn('campaign：', _this.campaign, _this)
            return this.campaign['only_impression_url']
        },
        action: reportPV
    }, {
        value: function(){
            //console.warn('campaign：', _this.campaign, _this)
            return this.campaign['pv_urls']
        },
        action: reportPV
    }, {
        value: function(){
            return [this.campaign.id]
        },
        action: reportImpressions
    }, {
        value: function(){
            return [this.campaign]
        },
        action: reportOfferImpression
    }, {
        targetSelector: '.jumpUrl',
        eventName: 'click',
        action: onScreenClick
    }])
    adShowed(res) {
        super.adShowed()
        //this.render()
        console.log('banner show =========> ', res)
        this.windowStartPoint = res&&res.param || {};
        //      this.playerView.play()

        if(device().isiOS){
            console.log("ios系统")
            let currentSDKVersion = App
                && App.initData
                && (App.initData.sdk_info || App.initData.appSetting
                    && App.initData.appSetting.sdk_info) || ''
            console.log("currentSDKVersion:",currentSDKVersion)
            if(checkIosSDKVersion({
                currentSDKVersion,
                minVersion: '6.2.0'
            })){
                console.log("大于等于6.2.0")
                this.initBannerCloseBtn()
            }
        }else {
            console.log("安卓系统")
            this.initBannerCloseBtn()
        }
    }

    /**
     * 初始化模板包含的各个组件
     */
    initComponents() {
        if(!this.container){
            //this.container = new Webview()
        }
    }



    /**
     * 设置关闭按钮显示状态
     * @param state 1 为默认出现， 2 为隐藏
     * @param cb
     */
    toggleCloseBtn(state) {
        console.log('toggleCloseBtn: ', state)
        let promise
        if (state === 1) {
            promise = showNativeCloseBtn()
        } else if(state === 2){
            promise = hideNativeCloseBtn()
        } else {
            promise = setNativeCloseBtnDisplay(state)
        }
        return promise
    }


    showCloseBtn(){
        return showNativeCloseBtn()
    }

    hideCloseBtn(){
        return hideNativeCloseBtn()
    }

    /**
     * 子类需要重写该方法，以判断模板的是否成功加载
     * @returns {Promise}
     */
    _isLoadFinish(){
        return super._isLoadFinish()
    }

}

export default BannerTemplate